export const firebase = require("firebase");
require("firebase/functions");
require("firebase/firestore");

firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
});

export const db = firebase.firestore();

export const functions = firebase.functions();

/**
 * - returns the firebase auth token of the current logged in user.
 * @returns {Promise<object>}
 */
export const getIdToken = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(idToken => {
        resolve(idToken);
      })
      .catch(error => {
        reject(error);
      });
  });
};

//firebase analytics
firebase.analytics();
